// Espelha ATS.Hub.API.Compras/Enums/OrigemCotacaoEnum.cs (domínio public.origem_cotacao).
export enum OrigemCotacaoEnum {
  Manual = 1,
  Planilha = 2,
  Link = 3,
}
